import { createApp } from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'

createApp(App).mount('#app')
